/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  Overrides,
  BigNumberish,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  TestableMembership,
  TestableMembershipInterface,
  LazyMinting,
} from "../TestableMembership";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol",
        type: "string",
      },
      {
        internalType: "string",
        name: "baseUri",
        type: "string",
      },
      {
        internalType: "address",
        name: "artpoolWallet",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "dropStart",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "dropEnd",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "string",
            name: "_id",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "maxEditions",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "artist",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "address",
                name: "wallet",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "stake",
                type: "uint256",
              },
            ],
            internalType: "struct LazyMinting.Stakeholder[]",
            name: "primaryStakeholders",
            type: "tuple[]",
          },
          {
            components: [
              {
                internalType: "address",
                name: "wallet",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "stake",
                type: "uint256",
              },
            ],
            internalType: "struct LazyMinting.Stakeholder",
            name: "eip2981Stakeholder",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "minMembershipTier",
            type: "uint256",
          },
        ],
        internalType: "struct LazyMinting.NftParams[]",
        name: "nftParamsArr",
        type: "tuple[]",
      },
      {
        internalType: "uint256[]",
        name: "tierList",
        type: "uint256[]",
      },
      {
        internalType: "address[]",
        name: "preSaleAccess",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "myRandomValues",
        type: "uint256[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "string",
        name: "nftIdIndex",
        type: "string",
      },
      {
        indexed: false,
        internalType: "string",
        name: "nftId",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "editionNumber",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "EditionMinted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "string",
        name: "nftIdIndex",
        type: "string",
      },
      {
        indexed: false,
        internalType: "string",
        name: "nftId",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "editionNumber",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "wallet",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "paymentValue",
        type: "uint256",
      },
    ],
    name: "MintingTransfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "_value",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "_id",
        type: "uint256",
      },
    ],
    name: "PermanentURI",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "artpoolWallet",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "nftId",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "editionNumber",
        type: "uint256",
      },
    ],
    name: "buildTokenUri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "nftId",
        type: "string",
      },
      {
        internalType: "address",
        name: "minter",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "msgValue",
        type: "uint256",
      },
    ],
    name: "canMintNft",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getCollectionInfo",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "dropStart",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "dropEnd",
            type: "uint256",
          },
        ],
        internalType: "struct LazyMinting.CollectionInfo",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "wallet",
        type: "address",
      },
    ],
    name: "getHighestMembershipTier",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "nftId",
        type: "string",
      },
    ],
    name: "getNftInfo",
    outputs: [
      {
        components: [
          {
            internalType: "string",
            name: "nftId",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "numMinted",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxEditions",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "minMembershipTier",
            type: "uint256",
          },
        ],
        internalType: "struct LazyMinting.NftInfo",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "nftId",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "editionNumber",
        type: "uint256",
      },
    ],
    name: "getTokenId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "nftInfoForToken",
    outputs: [
      {
        components: [
          {
            internalType: "string",
            name: "nftId",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "numMinted",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxEditions",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "minMembershipTier",
            type: "uint256",
          },
        ],
        internalType: "struct LazyMinting.NftInfo",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "nftId",
        type: "string",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
    ],
    name: "ownerMintTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_salePrice",
        type: "uint256",
      },
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type TestableMembershipConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TestableMembershipConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TestableMembership__factory extends ContractFactory {
  constructor(...args: TestableMembershipConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "TestableMembership";
  }

  deploy(
    name: string,
    symbol: string,
    baseUri: string,
    artpoolWallet: string,
    dropStart: BigNumberish,
    dropEnd: BigNumberish,
    nftParamsArr: LazyMinting.NftParamsStruct[],
    tierList: BigNumberish[],
    preSaleAccess: string[],
    myRandomValues: BigNumberish[],
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<TestableMembership> {
    return super.deploy(
      name,
      symbol,
      baseUri,
      artpoolWallet,
      dropStart,
      dropEnd,
      nftParamsArr,
      tierList,
      preSaleAccess,
      myRandomValues,
      overrides || {}
    ) as Promise<TestableMembership>;
  }
  getDeployTransaction(
    name: string,
    symbol: string,
    baseUri: string,
    artpoolWallet: string,
    dropStart: BigNumberish,
    dropEnd: BigNumberish,
    nftParamsArr: LazyMinting.NftParamsStruct[],
    tierList: BigNumberish[],
    preSaleAccess: string[],
    myRandomValues: BigNumberish[],
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      name,
      symbol,
      baseUri,
      artpoolWallet,
      dropStart,
      dropEnd,
      nftParamsArr,
      tierList,
      preSaleAccess,
      myRandomValues,
      overrides || {}
    );
  }
  attach(address: string): TestableMembership {
    return super.attach(address) as TestableMembership;
  }
  connect(signer: Signer): TestableMembership__factory {
    return super.connect(signer) as TestableMembership__factory;
  }
  static readonly contractName: "TestableMembership";
  public readonly contractName: "TestableMembership";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TestableMembershipInterface {
    return new utils.Interface(_abi) as TestableMembershipInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TestableMembership {
    return new Contract(address, _abi, signerOrProvider) as TestableMembership;
  }
}
